import { TActualApplicationResponse_1 as TActualApplicationResponse } from 'shared/common/repositories/mortgage/v2/actual-application';

import { ISubmittedApplication, TActualApplicationDecision } from '../types';
import { IAbortableRequest, withRequestTimeout } from './withRequestTimeout';

const NONE: TActualApplicationDecision = { kind: 'none' };

const mapApplication = (response: TActualApplicationResponse): ISubmittedApplication | null => {
  const { callSlot, contact, offers, searchParams } = response;

  if (!callSlot) {
    return null;
  }

  return {
    callSlot: { slotStart: callSlot.slotStart, slotEnd: callSlot.slotEnd },
    contact: contact
      ? { fullName: contact.fullName ?? null, phone: contact.phone ?? null, email: contact.email ?? null }
      : null,
    offers: offers
      ? {
          minMonthlyPayment: offers.minMonthlyPayment,
          minRate: offers.minRate,
          banksLogosPaths: offers.banksLogosPaths,
        }
      : null,
    searchParams: searchParams
      ? {
          objectCost: searchParams.objectCost,
          downPayment: searchParams.downPayment,
          loanTermYears: searchParams.loanTermYears,
          realEstateType: searchParams.realEstate?.type ?? null,
          benefitProgram: searchParams.benefitProgram ?? null,
        }
      : null,
  };
};

/** Любая неудача трактуется как «заявки нет»: оставить клик по CTA без результата хуже,
    чем показать лишний онбординг. */
export async function resolveActualApplication(
  request: IAbortableRequest<TActualApplicationResponse>,
): Promise<TActualApplicationDecision> {
  try {
    const response = await withRequestTimeout(request);

    /* Порядок проверки фиксируем здесь: бэк флаги не смешивает, но приоритет не должен
       зависеть от порядка полей в ответе */
    if (response.isSubmitted) {
      const application = mapApplication(response);

      return application ? { kind: 'submitted', application } : NONE;
    }

    return response.isDraft ? { kind: 'draft' } : NONE;
  } catch {
    return NONE;
  }
}
